import { BrowserRouter, Route, Routes } from "react-router-dom";

import { AppLayout } from "../components/layout";
import { DemandNoPerspectivePage } from "./demand_no_perspective";
import { DemandPreviewPage } from "./demand_preview";
import { DemandWalkSinglePage } from "./demand_walk_single";
import { ChatAssistantPage } from "./chat_assistant";
import { POExportNoPerspectivePage } from "./po_export_no_perspective";
import { ProfilePage } from "./profile";
import { RunHistoryPage } from "./run_history";
import { SupplyNoPerspectivePage } from "./supply_no_perspective";
import { SupplyWalkNoPerspectivePage } from "./supply_walk_no_perspective";
import { SupplyWalkSinglePage } from "./supply_walk_single";
import InventoryHealthPage from "./inventory_health";
import InventoryHealthMRPPage from "./inventory_health_mrp";
import { TransferPlanningPage } from "./transfer_planning";
import { InventoryNoPerspectivePage } from "./inventory";
import { AvantiCardRunsPage } from "./avanti_card_runs";
import { PurchaseOrderExportPeachAndLilyPage } from "./purchase_order_export_peach_and_lily";
import { SupplyWalkEditablePage } from "./supply_walk_editable";
import { MyTeamPage } from "./my_team";
import { AuthCallbackComponent } from "../components/authentication/callback";

export const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route index element={<RunHistoryPage />} />
          <Route index path="/run-history" element={<RunHistoryPage />} />

          <Route index path="/demand" element={<DemandNoPerspectivePage />} />
          <Route index path="/demand_preview" element={<DemandPreviewPage />} />

          <Route
            path="/demand-walk-single"
            element={<DemandWalkSinglePage />}
          />

          <Route index path="/supply" element={<SupplyNoPerspectivePage />} />

          <Route
            index
            path="/supply-walk"
            element={<SupplyWalkNoPerspectivePage />}
          />

          <Route
            index
            path="/supply-walk-single"
            element={<SupplyWalkSinglePage />}
          />

          <Route path="/po-export" element={<POExportNoPerspectivePage />} />

          <Route index path="/chat" element={<ChatAssistantPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route
            index
            path="/inventory-health"
            element={<InventoryHealthPage />}
          />
          <Route
            index
            path="/inventory-health-mrp"
            element={<InventoryHealthMRPPage />}
          />
          <Route
            index
            path="/inventory"
            element={<InventoryNoPerspectivePage />}
          />
          <Route
            index
            path="/transfer-planning"
            element={<TransferPlanningPage />}
          />
          <Route
            index
            path="/avanti-card-runs"
            element={<AvantiCardRunsPage />}
          />
          <Route
            path="/purchase-order-export-peach-and-lily"
            element={<PurchaseOrderExportPeachAndLilyPage />}
          />
          <Route path="/po-inbox" element={<SupplyWalkEditablePage />} />
          <Route path="/my-team" element={<MyTeamPage />} />
        </Route>

        {/* OAuth callback route - outside of AppLayout since user is not authenticated yet */}
        <Route path="/callback" element={<AuthCallbackComponent />} />
      </Routes>
    </BrowserRouter>
  );
};
